(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/tickets/assets/javascripts/cookie-monster.js') >= 0) return;  svs.modules.push('/templates/tickets/assets/javascripts/cookie-monster.js');
"use strict";


if (svs.core.detect.feature('ft-lotter-cookie-monster')) {
  const logger = svs.core.log.getLogger('template_tickets:cookie-monster');
  const cookieMonster = async () => {
    if (!cookieStore) {
      logger.warn('Cookie Monster might be hungry but cookieStore is not available');
      return;
    }
    logger.info('Cookie Monster is looking for cookies');
    const cookies = await cookieStore.getAll();
    if ((cookies === null || cookies === void 0 ? void 0 : cookies.length) >= 38) {
      logger.warn("Cookie Monster is hungry and found ".concat(cookies.length, " cookies!"));
      const mouth = [];
      const gaCookies = cookies.filter(cookie => {
        var _cookie$name, _cookie$name$startsWi;
        return ((_cookie$name = cookie.name) === null || _cookie$name === void 0 || (_cookie$name$startsWi = _cookie$name.startsWith) === null || _cookie$name$startsWi === void 0 ? void 0 : _cookie$name$startsWi.call(_cookie$name, '_ga_')) && cookie.name !== '_ga_5KHKH7YLPF';
      });
      if (gaCookies.length > 0) {
        mouth.push(...gaCookies);
      }
      const hjCookies = cookies.filter(cookie => {
        var _cookie$name2, _cookie$name2$startsW;
        return ((_cookie$name2 = cookie.name) === null || _cookie$name2 === void 0 || (_cookie$name2$startsW = _cookie$name2.startsWith) === null || _cookie$name2$startsW === void 0 ? void 0 : _cookie$name2$startsW.call(_cookie$name2, '_hjSession')) && cookie.name !== '_hjSession_3618445' && cookie.name !== '_hjSessionUser_3618445';
      });
      if (hjCookies.length > 0) {
        mouth.push(...hjCookies);
      }
      logger.info("Cookie Monster is eating ".concat(mouth.length, " cookies: ").concat(mouth.join(', ')));
      mouth.forEach(cookie => {
        cookieStore.delete(cookie);
      });
      const remainingCookies = await cookieStore.getAll();
      logger.info("Cookie Monster is full and left ".concat(remainingCookies.length, " cookies"));
      if (remainingCookies.length !== cookies.length - mouth.length) {
        logger.info("Cookie Monster was unable to eat ".concat(remainingCookies.length - (cookies.length - mouth.length), " cookies"));
      }
      if (remainingCookies.length > 38) {
        logger.warn("Cookie Monster is still hungry and will eat as many cookies as possible!");
        remainingCookies.forEach(cookie => {
          if (['svssid', 'devid', 'uid', 'tur', 'OptanonConsent', 'OptanonAlertBoxClosed'].includes(cookie.name)) {
            return;
          }
          cookieStore.delete(cookie);
        });
        const finalCookies = await cookieStore.getAll();
        logger.info("Cookie Monster ate all but ".concat(finalCookies.length, " cookies"));
      }
    } else {
      logger.info("Cookie Monster found ".concat(cookies.length, " cookies but is not hungry"));
    }
  };
  cookieMonster();
}

 })(window);